export class Site {
  id!: number;
  company!: string;
  slug!: string;
  geo_lat!: number;
  geo_lng!: number;
  // content: string;
  site_url!: string;
  title!: string;
  description!: string;
  address!: string;
  zip!: string;
  city!: string;
  country!: string;
  tagNames?: string | null;
  image: string | null = null;
  screenshot_path: string | null = null;
  favicon_path: string | null = null;
  social_media_url_twitter: string | null = null;
  social_media_url_facebook: string | null = null;
  social_media_url_linkedin: string | null = null;
  social_media_url_xing: string | null = null;
  social_media_url_tiktok: string | null = null;
  social_media_url_instagram: string | null = null;
  social_media_url_youtube: string | null = null;
  fulltextMarked: string | null = null;
  score: number | null = null;

  constructor(props: Partial<Site> = {}) {
    Object.assign(this, props);
  }

  // @todo move to helper
  static urlDomain(url: string) {
    const urlObj = new URL(url);
    return urlObj.hostname.replace(/^www\./, '');
  }
}
